import { useInitData } from '../../../hooks'
import { Loader } from '../../Loader'
import { AuthLayout } from '../AuthLayout'

function Auth({ children, loading }) {
  const { authorized } = useInitData()

  return authorized || loading ? (
    <Loader />
  ) : (
    <AuthLayout>{children}</AuthLayout>
  )
}

export default Auth
